import React from 'react';
import PropTypes from 'prop-types';
import { AspectRatio, Box, Icon, Text, Flex } from '@chakra-ui/react';
import { MdPlayCircle } from 'react-icons/md';

import Image from '@rsc/ui-components/tailwind/Image';

function SocialGridItem({ block, handleClick }) {
  const { media, headline, copy } = block;
  return (
    <Box onClick={() => handleClick(block)}>
      <Flex
        pos="relative"
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
      >
        <AspectRatio ratio={16 / 9} width={['18.8rem', null, '100%']}>
          <Image
            alt={headline}
            className="rounded-t-md w-full [&>img]:w-full"
            ratio={null}
            src={media?.video?.thumbnail}
          />
        </AspectRatio>
        <Flex
          position="absolute"
          background="linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%),#d3d3d338 50%/cover no-repeat"
          width="100%"
          height="100%"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          borderRadius="8px 8px 0 0"
        >
          <Box>
            <Icon as={MdPlayCircle} color="brand.sunny" w="9" h="9" />
          </Box>
        </Flex>
      </Flex>
      <Box p={4}>
        <Text fontWeight="bold" mb={2} h={12} noOfLines={2}>
          {headline}
        </Text>
        <Text textStyle="caption">{copy}</Text>
      </Box>
    </Box>
  );
}

SocialGridItem.propTypes = {
  block: PropTypes.shape({
    media: PropTypes.shape({
      video: PropTypes.shape({
        url: PropTypes.string,
        thumbnail: PropTypes.string,
      }),
    }).isRequired,
    headline: PropTypes.string.isRequired,
    copy: PropTypes.string.isRequired,
  }).isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default SocialGridItem;
